import React from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import PostCreateContainer from '../../../features/page/post/post/CreatePostContainer'

interface IProps {
    className?: string
}

const PostCreatePage: React.FC<IProps> = ({className}) => {
    return (
        <PageLayout title={'Post Create'} className={`${className}`}>
            <PostCreateContainer />
        </PageLayout>
    )
}

export default PostCreatePage
